// extracted by mini-css-extract-plugin
module.exports = {"container":"PositionsUpload_container__gykoz"};